import * as React from 'react';

import {colors} from '../../colors/colors';
import {GoogleCalendarIcon} from '../../icon/svg/google-calendar-icon';
import {OutlookCalendarIcon} from '../../icon/svg/outlook-calendar-icon';
import {WarningIcon} from '../../icon/svg/warning-icon';
import {Body} from '../../typography/body';

type Props = {
    name: string;
    size?: 'small' | 'normal';
    externalService: 'OFFICE365' | 'GOOGLE';
    syncErrors: string[];
};

export function CalendarListItem(props: Props) {
    const {size = 'normal'} = props;

    const hasSyncErrors = props.syncErrors.length > 0;
    const iconSize = size === 'small' ? 11 : 13;

    let icon = null;
    if (hasSyncErrors) {
        icon = (
            <WarningIcon
                size={iconSize}
                className='flex align-center'
                // @ts-expect-error
                color={colors.orangeAttention}
                data-tip={props.syncErrors[0]}
                data-place='bottom'
            />
        );
    } else if (props.externalService === 'OFFICE365') {
        icon = <OutlookCalendarIcon size={iconSize} className='flex align-center' />;
    } else if (props.externalService === 'GOOGLE') {
        icon = <GoogleCalendarIcon size={iconSize} className='flex align-center' />;
    }

    return (
        <div className='flex align-center gap-4 max-full-width'>
            {icon}
            <Body truncate={{type: 'block'}} size={size}>
                {props.name}
            </Body>
        </div>
    );
}
